import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import QuoteWizard from "@/components/QuoteWizard";

export default function QuotePage() {
  return (
    <>
      <Navbar />
      <QuoteWizard />
      <Footer />
    </>
  );
}
